import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSystemThemeDark = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "system-theme-dark-icon",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("mask", {
			id: "std-cut",
			children: [/* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white"
			}), /* @__PURE__ */ _jsx("rect", {
				x: 13.16,
				y: 13.64,
				width: 9.6,
				height: 6.72,
				rx: 1.44,
				fill: "black"
			})]
		}) }),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#std-cut)",
			children: /* @__PURE__ */ _jsx("g", {
				transform: "translate(10.5 10.5) scale(0.85) translate(-12 -12)",
				children: /* @__PURE__ */ _jsx("path", { d: "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z" })
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			transform: "translate(12.2 12.2) scale(0.48)",
			children: [/* @__PURE__ */ _jsx("rect", {
				width: 18,
				height: 12,
				x: 3,
				y: 4,
				rx: 2
			}), /* @__PURE__ */ _jsx("path", { d: "M2 20h20" })]
		})
	]
});
export default SvgSystemThemeDark;
